import {
    defineStore,
} from 'pinia'
import {
    useStorage,
} from '@vueuse/core'
import {
    useLogStore,
} from '~~/stores/log'

export type ThemeMode = 'dark' | 'light' | 'auto'

export const useAppStore = defineStore('app', {
    state: () => {
        return {
            isMenuOpen: useStorage('menu-open', true, localStorage),
            isLogOpen: useStorage('log-open', true, localStorage),
            themeMode: useStorage<ThemeMode>('theme-mode', 'auto', localStorage),
            menuWidth: useStorage('menu-width', 200, localStorage),
            logWidth: useStorage('log-width', 300, localStorage),
        }
    },

    actions: {
        toggleMenu() {
            const logStore = useLogStore()
            this.isMenuOpen = !this.isMenuOpen
            logStore.info('toggling menu', this.isMenuOpen)
        },

        toggleLog() {
            const logStore = useLogStore()
            this.isLogOpen = !this.isLogOpen
            logStore.info('toggling log', this.isLogOpen)
        },

        setThemeMode(mode: ThemeMode) {
            const logStore = useLogStore()
            this.themeMode = mode
            logStore.info('setting theme mode', this.themeMode)
        },
    },
})
